'use strict';

(function ($) {
  var classFullName;

  $.fn.subMenu = function (options) {
    var defaults = {
      hideAfter: 991,
      animateTime: 800
    };
    options = $.extend(defaults, options);
    var hide_after = options.hideAfter;
    var animate = options.animateTime;

    classFullName = "." + $(this).attr('class');
    var className = classFullName.replace(/ .*/, '');
    var navHeight,
      stickyHeight,
      finalHeight,
      windowOffset,
      stickyOffset,
      addedValue = 0;
    navHeight = $('header').height();
    stickyHeight = $(className).outerHeight();
    if ($("body").hasClass('admin-bar')) {
      addedValue = 32;
    } else if ($("body").hasClass('toolbar-fixed') && $("body").hasClass('toolbar-horizontal')) {
      addedValue = 81;
    }
    finalHeight = navHeight + stickyHeight + addedValue;
    var navWithAdmin = 0;
    var nav_header_height = 0;
    if ($("header").hasClass("fixed")) {
      navWithAdmin = navHeight + addedValue;
      nav_header_height = 0;
    } else {
      navWithAdmin = 0;
      nav_header_height = 91;
    }
    windowOffset = $(window).scrollTop();
    stickyOffset = $(className).offset().top - navHeight + nav_header_height;
    if (windowOffset > stickyOffset) {
      $(className).children().css({
        'position': 'fixed',
        'top': navWithAdmin
      });
    } else {
      $(className).children().removeAttr('style');
    }
    $($(this).find("a")).off().on('click', function (f) {
      if (this.hash !== "") {
        f.preventDefault();
        var hash = this.hash;
        $('html, body').animate({
          scrollTop: $(hash).offset().top - finalHeight + 10
        }, animate, function () {
        });
      }
    });
    var scrollPos = $(window).scrollTop() + finalHeight + 10;
    $(className).find('li').removeClass("active");
    var refElement;

    $(className).find('a').each(function () {
      if (this.hash !== "") {
        refElement = $($(this).attr("href"));
        if (refElement.offset().top <= scrollPos && refElement.offset().top < scrollPos) {
          $(className).find('li').removeClass("active");
          $(this).parent().addClass("active");
        }
      }
    });

    var win_width = $(window).width();
    if (win_width <= hide_after) {
      $(className).hide();
    } else {
      $(className).show();
    }
  };
})(jQuery);
//# sourceMappingURL=sticky-min.js.map
